<style scoped lang="scss">
    @import "../../styles/var";

    ul {
        flex-wrap: wrap;

        li {
            width: (100%/3);
        }
    }

    img {
        height: 21px;
    }
</style>
<template>
    <div class="list">
        <ul class="flex">
            <li v-for="(val,key) in list" class="flex0 flex column pointer aic jcc pt10 pb10">
                <div class="icon"><img :src="val" alt=""></div>
                <div class="text color_333 fs14">{{key}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
  const ACTIONS_MAP = {
    '检查报告': require('../../assets/icon/consult/检查报告.png'),
    '检验报告': require('../../assets/icon/consult/检验报告.png'),
    '体检报告': require('../../assets/icon/consult/体检报告.png'),
    '咨询记录': require('../../assets/icon/consult/咨询记录.png'),
    '处方记录': require('../../assets/icon/consult/处方记录.png'),
    '健康日记': require('../../assets/icon/consult/健康日记.png'),
  };
  export default {
    name: "consult-actions",
    components: {},
    props: {},
    data() {
      return {
        list: ACTIONS_MAP
      }
    },
    computed: {},
    created() {
    },
    methods: {}
  }
</script>
